/**
 * AdminPanelLink — Botão na sidebar que leva ao /admin
 * Story SAAS-3.4 / EPIC-SAAS-001
 *
 * Visível apenas para super_admin e org_admin.
 */

import { useNavigate } from "react-router-dom";
import { useTenant } from "@/contexts/TenantContext";
import { Button } from "@/components/ui/button";
import { Settings } from "lucide-react";

export function AdminPanelLink() {
  const navigate = useNavigate();
  const { isSuperAdmin, isOrgAdmin, isLoading } = useTenant();

  if (isLoading || (!isSuperAdmin && !isOrgAdmin)) {
    return null;
  }

  return (
    <Button
      variant="default"
      size="sm"
      onClick={() => navigate("/admin")}
      className="gap-2 w-full justify-start"
    >
      <Settings className="h-4 w-4 shrink-0" />
      <span className="text-xs">Painel Admin</span>
    </Button>
  );
}
